/**
 * Created by Daniela on 23/01/2017.
 */
import { Injectable } from '@angular/core';

import { AuthService } from "../../../shared/services/auth.service";
import { editRoute, newRoute, detailRoute } from "../../../shared/services/data.service";
import { abastecimentosRoute } from "../../shared/data.service";
import { tanquesRoute, tanquesEstoqueRoute, tanquesMovimentacaoRoute } from "./data.service";

@Injectable()
export class TanqueNavigationService {

    constructor(
        private _authService: AuthService
    ) { }

    goToList() {
        let router: string = abastecimentosRoute + '/' + tanquesRoute;
        this._authService.navigateTo(router);
    }

    goToNew() {
        let router: string = abastecimentosRoute + '/' + tanquesRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }

    goToEdit(objectId: number) {
        let router: string = abastecimentosRoute + '/' + tanquesRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToEstoque() {
        let router: string = abastecimentosRoute + '/' + tanquesRoute + '/' + tanquesEstoqueRoute;
        this._authService.navigateTo(router);
    }

    goToMovimentacaoDetail(tanqueId: number) {
        let router: string = abastecimentosRoute + '/' + tanquesRoute + '/' + tanquesMovimentacaoRoute + '/' + detailRoute;
        this._authService.navigateTo(router, tanqueId);
    }

    goToMovimentacaoEdit(objectId: number) {
        let router: string = abastecimentosRoute + '/' + tanquesRoute + '/' + tanquesMovimentacaoRoute + '/' + editRoute;
        this._authService.navigateTo(router, objectId);
    }

    goToMovimentacaoNew() {
        let router: string = abastecimentosRoute + '/' + tanquesRoute + '/' + tanquesMovimentacaoRoute + '/' + newRoute;
        this._authService.navigateTo(router);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/tanques/shared/tanque-navigation.service.ts
 **/